import Vue from 'vue'
import '@/main-config'

import { ToastPlugin, ModalPlugin, BootstrapVue } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueApexCharts from 'vue-apexcharts';

// Amplify Importing
import {
  applyPolyfills,
  defineCustomElements
} from '@aws-amplify/ui-components/loader'

import { Amplify, Auth } from 'aws-amplify'
// eslint-disable-next-line camelcase
import aws_exports from '@/aws-exports'

import i18n from '@/libs/i18n'
import store from './store'
import router from './router'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/vue-select'
import '@core/logger'
import '@core/filterV2'
import '@core/filter'

// Bootstrap
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Axios Mock Adapter

Amplify.configure(aws_exports)
Auth.configure(aws_exports)
applyPolyfills().then(() => {
  defineCustomElements(window)
})

Vue.config.ignoredElements = [/amplify-\w*/]

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// BoostrapVue mount
Vue.use(BootstrapVue)

// Composition API
Vue.use(VueCompositionAPI)

// VueApexCharts mount
Vue.component('vue-apex-charts', VueApexCharts);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

// import custom styles for dark purple menu
require('@/assets/scss/custom-styles.scss')

Vue.config.productionTip = false

/*
Vue.config.errorHandler = (err, vm, info) => {
  Vue.prototype.$logger.methods.vueError(err, info)
}
Vue.config.warnHandler = (msg, vm, trace) => {
  Vue.prototype.$logger.methods.vueWarn(msg, trace)
}

window.onerror = function (message, source, lineno, colno, error) {
  Vue.prototype.$logger.methods.windowError(message, source, lineno, colno, error)
}
*/

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
